import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { tariffsApi } from '../client';
import type { Country } from '../types';
import type { components } from '../generated/schema';

type CountryCreate = components['schemas']['CountryCreateRequest'];
type CountryUpdate = components['schemas']['CountryUpdateRequest'];

export const countriesAdapter: CrudAdapter<Country, CountryCreate, CountryUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await tariffsApi.GET('/countries/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await tariffsApi.POST('/countries/', { body: payload });
    if (error) throw error;
    return { id: (data as { id?: number } | undefined)?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await tariffsApi.PUT('/countries/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as unknown as Country;
  },
  async byKey(id) {
    const { data, error } = await tariffsApi.GET('/countries/{country_id}', {
      params: { path: { country_id: Number(id) } },
    });
    if (error) throw error;
    return data as Country;
  },
  async remove(id) {
    const { error } = await tariffsApi.DELETE('/countries/{country_id}', {
      params: { path: { country_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const countriesStore = useCrudDataSource(countriesAdapter);
